export default "__VITE_ASSET__BurmtzCu__"